import React from "react";
import { Link } from "react-router-dom";
import { ProgressiveImage } from "../ProgressiveImage/ProgressiveImage"; // Укажите правильный путь к компоненту
// import PropTypes from 'prop-types';

const DisciplineSlide = ({
  id,
  discipline,
  description,
  imageUrl,
  imageUrl2x,
  imageUrl3x,
  link,
}) => {
  const imgConfig = [
    {
      breakpoint: "xs",
      url: imageUrl,
      url2x: imageUrl2x,
    },
  ];

  return (
    <div id={id} className="slide tbk-h-100 tbk-px-1">
      <div
        className="content js-progressive-image slide-bg tbk-relative tbk-w-full tbk-overflow-hidden tbk-rounded-lg tbk-px-2 tbk-pb-2 tbk-pt-3 tbk-grayscale tbk-transition-all tbk-duration-300 hover:tbk-grayscale-0"
        style={{ width: "100%", height: "100%" }}
      >
        <div className="home-slider-img-wrapper tbk-absolute tbk-left-0 tbk-top-0 tbk-h-full tbk-w-full">
          <ProgressiveImage
            src={imageUrl}
            alt="Personal Trainers in Los Angeles"
            imgConfig={imgConfig}
            defaultBreakpoint="xs"
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            className="tbk-h-full tbk-w-full tbk-object-cover"
            imgStyle={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
        <Link to={link}>
          <div className="tbk-relative tbk-z-1 tbk-flex tbk-h-full tbk-flex-col tbk-justify-end tbk-rounded-lg">
            <div className="tbk-text-epic-medium tbk-mb-1 !tbk-leading-none tbk-text-basic-white">
              {discipline}
            </div>
            <div className="tbk-text-secondary tbk-text-basic-white">
              {description}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

// DisciplineCard.propTypes = {
//   id: PropTypes.string.isRequired,
//   discipline: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
//   imageUrl: PropTypes.string.isRequired,
//   imageUrl2x: PropTypes.string.isRequired,
//   imageUrl3x: PropTypes.string.isRequired,
//   link: PropTypes.string.isRequired,
// };

export default DisciplineSlide;
